import React from 'react';
import { Base } from 'lib/cortiUI';
import { ShowMoreAction } from './ShowMoreAction';
export const Actions = ({ feedbackFormTemplateID }) => {
    return (React.createElement(Base, { display: "flex", flexDirection: "row", gap: 2 },
        React.createElement(ShowMoreAction, { feedbackFormTemplateID: feedbackFormTemplateID })));
};
export * from './AnonymizeToggle';
